import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

var InputFiled =
/*#__PURE__*/
function (_Vue) {
  _inherits(InputFiled, _Vue);

  function InputFiled() {
    var _this;

    _classCallCheck(this, InputFiled);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputFiled).apply(this, arguments));
    _this.inputValue = "";
    _this.inputFocus = false;
    return _this;
  }

  _createClass(InputFiled, [{
    key: "focusInput",
    value: function focusInput() {
      this.inputFocus = true;
    }
  }, {
    key: "blurIpnut",
    value: function blurIpnut() {
      this.inputFocus = false;
    }
  }, {
    key: "onChildChanged",
    value: function onChildChanged(val, oldVal) {
      this.$emit("input", val);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.inputValue = this.value;
    }
  }, {
    key: "borderStyle",
    get: function get() {
      return this.inputFocus ? 'focusBorder' : 'blurBorder';
    }
  }]);

  return InputFiled;
}(Vue);

tslib_1.__decorate([Prop({
  default: ""
})], InputFiled.prototype, "placeholderText", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], InputFiled.prototype, "value", void 0);

tslib_1.__decorate([Watch("inputValue", {
  immediate: true
})], InputFiled.prototype, "onChildChanged", null);

InputFiled = tslib_1.__decorate([Component({
  components: {}
})], InputFiled);
export default InputFiled;